// extracted by mini-css-extract-plugin
export default {"wrapper":"XFPL58wRqDMSWGMi5_cQ","open":"T_SXIFmFhqVxaBflhfHl"};